var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{class:("float_btn_dialog_wrp " + _vm.type)},[_c('div',{staticClass:"dialog"},[_c(_vm.type,{tag:"div",on:{"handleClose":_vm.handleClose}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }